import { format, parse } from 'date-fns';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { SCCalendar, SCCheckbox, SCDropdown, SCFieldset, SCInputMask } from '../components';
import Loading from '../components/Loading';
import { useToast } from '../context/ToastContext';
import { useAuth } from '../providers/auth';
import api from "../services/api";
import { MESES, SITUACAO_ALUNO } from '../utilities/constantes';
import AjudaFormTela from './AjudaFormTela';

interface Periodo {
  Ano: number;
  Descricao: string;
  Sequencial: string;
}

type Inadimplente = {
  AlunosPeriodoId: number;
  DiaPadraoVencimento: number;
  InadimplenteDataRetorno: string; // Está no formato "dd/MM/yyyy"
  InadimplenteObs: string;
  InadimplenteObsAnterior: string;
  Matricula: number;
  NomeAluno: string;
  ParcelasEmAberto: string; // Está como uma string separada por vírgulas
  Situacao: string; // Pode ser uma enum se houver valores fixos (ex.: "S" para Sim, "N" para Não)
  TotalEmAberto: string; // Está formatado como moeda, então permanece string
  Turma: string;
};



const InadimplentesObservacao = () => {
  const toast = useToast();
  const { periodoSelecionado, usuario } = useAuth();
  const tarefa = 'AjustaInformacaoDiarioFinanceiro';

  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [usuarios, setUsuario] = useState<any>([]);
  const [formasPagamento, setFormasPagamento] = useState<any>([]);
  const [fonte, setFonte] = useState<any>([]);
  const [tarefas, setTarefas] = useState<any>([]);
  const [nome, setNome] = useState<any>([]);
  const [arrayIds, setArrayIds] = useState<any[]>([]);
  const [loading, setLoading] = useState(false)
  const [turmas, setTurmas] = useState([])
  const [parcelas, setParcelas] = useState<{ label: string, value: string | number }[]>([]);
  const [listaInadimplentes, setListaInadimplentes] = useState<Inadimplente[]>([]);
  const [listaInadimplentesCopia, setListaInadimplentesCopia] = useState<Inadimplente[]>([]);

  const methods = useForm();
  const { control, watch, setValue } = methods;

  const watchSituacao = watch('Situacao')
  const watchTurmas = watch('Turmas')

  const watchDataRetornoInicial = watch('DataRetornoInicial')
  const watchDataRetornoFinal = watch('DataRetornoFinal')

  const watchParcelaInicial = watch('ParcelaInicial')
  const watchParcelaFinal = watch('ParcelaFinal')

  const watchObsRegistrada = watch('ObsRegistradas')
  const watchDebAcrescimo = watch('DebAcrescimo')

  const pesquisa = async () => {

    if (watchDataRetornoInicial > watchDataRetornoFinal) {
      toast.showToast({ severity: 'error', summary: 'Atenção', detail: 'Data Retorno Inicial é maior que Data Retorno Final.' });
      return
    }

    if (watchParcelaInicial > watchParcelaFinal) {
      toast.showToast({ severity: 'error', summary: 'Atenção', detail: 'Parcela Inicial é maior que Parcela Final.' });
      return
    }

    setLoading(true);

    try {
      const consultaMensalidades = await api.get('/mensalidades/filtroMensalidadesEmAberto', {
        params: {
          EmpresaId: periodoSelecionado?.EmpresaId,
          Ano: periodoSelecionado?.Ano,
          Sequencial: periodoSelecionado?.Sequencial,
          SituacaoAcademica: watchSituacao,
          Turma: watchTurmas,
          DataRetornoIni: watchDataRetornoInicial ? format(watchDataRetornoInicial, 'yyyy-MM-dd') : null,
          DataRetornoFin: watchDataRetornoFinal ? format(watchDataRetornoFinal, 'yyyy-MM-dd') : null,
          ParcelaInicial: watchParcelaInicial,
          ParcelaFinal: watchParcelaFinal,
          SomenteObsReg: watchObsRegistrada,
          DebitoAcrescimo: watchDebAcrescimo
        }
      });

      if (consultaMensalidades.data) {
        let lendoDadosMensalidades = consultaMensalidades.data.map((mensal: any) => {
          let descricaoSituacao = SITUACAO_ALUNO.find((sit: any) => sit.value === mensal.Situacao)?.descricao;
          return {
            ...mensal,
            DescricaoSituacao: descricaoSituacao
          };
        });

        console.log(lendoDadosMensalidades)

        setListaInadimplentes(lendoDadosMensalidades);
        setListaInadimplentesCopia(lendoDadosMensalidades);
      }


    } catch (error) {
      console.log('Erro na pesquisa', error);
      setListaInadimplentes([]);
      setListaInadimplentesCopia([]);
    }

    setLoading(false);
  };

  const load = async () => {
    const resultOperador = await api.get('/diariofinanceiro/listColunasDiarioFinanceiro', {
      params: {
        EmpresaId: periodoSelecionado?.EmpresaId,
        Ano: periodoSelecionado?.Ano,
        Sequencial: periodoSelecionado?.Sequencial,
        ShowLancamentoOperador: true
      }
    })

    if (resultOperador.data.length > 0) {
      setUsuario(resultOperador.data)
    } else {
      setUsuario([])
    }

    const resultFormasPagamento = await api.get('/formasPagamento/list')
    if (resultFormasPagamento.data.length > 0) {
      setFormasPagamento(resultFormasPagamento.data)
    } else {
      setFormasPagamento([])
    }

    const resultFontes = await api.get('/fontes/list', {
      params: {
        EmpresaId: periodoSelecionado?.EmpresaId
      }
    })

    if (resultFontes.data.length > 0) {
      setFonte(resultFontes.data)
    } else {
      setFonte([])
    }

    const resultTarefas = await api.get('/diariofinanceiro/listColunasDiarioFinanceiro', {
      params: {
        EmpresaId: periodoSelecionado?.EmpresaId,
        Ano: periodoSelecionado?.Ano,
        Sequencial: periodoSelecionado?.Sequencial,
        ShowTarefa: true
      }
    })

    if (resultTarefas.data.length > 0) {
      setTarefas(resultTarefas.data)
    } else {
      setTarefas([])
    }

    const resultNome = await api.get('/diariofinanceiro/listColunasDiarioFinanceiro', {
      params: {
        EmpresaId: periodoSelecionado?.EmpresaId,
        Ano: periodoSelecionado?.Ano,
        Sequencial: periodoSelecionado?.Sequencial,
        ShowNome: true
      }
    })

    if (resultNome.data.length > 0) {
      setNome(resultNome.data)
    } else {
      setNome([])
    }
  };

  const loadTurmas = async () => {
    const resultTurmas = await api.get('/turmas/combo', {
      params: {
        EmpresaId: periodoSelecionado?.EmpresaId,
        Ano: periodoSelecionado?.Ano,
        Sequencial: periodoSelecionado?.Sequencial,
      }
    })

    if (resultTurmas.data) {
      console.log(resultTurmas.data)
      setTurmas(resultTurmas.data)
    } else {
      setTurmas([])
    }
  }

  const comboParcelas = async () => {
    // Formata os meses (MESES)
    const mesesFormatados = MESES.map(mes => ({
      label: mes.des,
      value: mes.mes
    }));

    // Chama a API e formata as parcelas extras
    const parcelaExtraResponse = await api.get('/parcelaExtra/lista');
    const parcelasExtras = parcelaExtraResponse.data.map((p: any) => ({
      label: `Parcela ${p.Parcela}`,
      value: p.Parcela
    }));

    // Junta os dois arrays
    const listaFinal = [...mesesFormatados, ...parcelasExtras];

    setParcelas(listaFinal)
  };

  const saoIguais = (arr1: any[], arr2: any[]) => {
    if (arr1.length !== arr2.length) return false;

    return arr1.every((obj1, index) => {
      const obj2 = arr2[index];
      return JSON.stringify(obj1) === JSON.stringify(obj2);
    });
  };

  const onSubmit = async () => {

    setLoading(true)

    const dataHoje = new Date();
    const dataHojeConv = format(dataHoje, 'yyyy-MM-dd');
    const horaAtual = format(dataHoje, 'HH:mm:ss');

    // Comparação antes de iniciar o processo de gravação
    if (!saoIguais(listaInadimplentes, listaInadimplentesCopia)) {
      try {
        // Filtrando apenas os que mudaram
        const listaAlterada = listaInadimplentes.filter((dados, index) => {
          return JSON.stringify(dados) !== JSON.stringify(listaInadimplentesCopia[index]);
        });

        // Map para criar as requisições
        const requisicoes = listaAlterada.map((dados) => {
          const dadosGravacao = {
            AlunosPeriodoId: dados.AlunosPeriodoId,
            InadimplenteData: dataHojeConv,
            InadimplenteHora: horaAtual,
            InadimplenteOperador: usuario?.Apelido,
            InadimplenteObsAnterior: dados.InadimplenteObsAnterior ?? null,
            InadimplenteObs: dados.InadimplenteObs ?? null,
            InadimplenteDataRetorno: dados.InadimplenteDataRetorno
              ? format(parse(dados.InadimplenteDataRetorno, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd')
              : null,
          };

          // Retorna a Promise da requisição para ser executada em paralelo
          return api.put('/alunosPeriodo/updateInadimplenteObs', dadosGravacao);
        });

        // Executa todas as requisições em paralelo
        await Promise.all(requisicoes);

        setLoading(false)

        toast.showToast({ severity: 'success', summary: 'Atenção', detail: 'Alterações salvas com sucesso!' });

      } catch (error) {
        console.error("Erro ao gravar inadimplente:", error);
        setLoading(false)
      }
    } else {
      toast.showToast({ severity: 'info', summary: 'Atenção', detail: 'Nenhuma alteração ao ser salva' });
      console.log("Nenhuma alteração detectada");
      setLoading(false)
    }
  };

  const onEditorValueChange = (
    props: { rowIndex: number; field: keyof Inadimplente },
    value: Inadimplente[keyof Inadimplente] // Tipagem correta para o valor
  ) => {
    // Clonando a lista atual
    const updatedInadimplenteObs: Inadimplente[] = [...listaInadimplentes];

    // Garantindo que a chave é válida e atribuindo o valor de forma segura
    updatedInadimplenteObs[props.rowIndex] = {
      ...updatedInadimplenteObs[props.rowIndex],
      [props.field]: value as Inadimplente[keyof Inadimplente],
    };

    // Atualizando o estado
    setListaInadimplentes(updatedInadimplenteObs);
  };

  const inputDateEditor = (props: any) => {
    const field = props.field;
    const rowIndex = props.rowIndex;

    const handleBlur = (e: any) => {
      const value = e.target.value;
      onEditorValueChange({ field, rowIndex }, value);
      const id = props.rowData.Matricula;

      if (id && !arrayIds.includes(id)) {
        setArrayIds(prevArrayIds => [...prevArrayIds, id]);
      }
    };

    const handleControl = (e: any) => {
      const charCode = e.charCode;
    };

    return (
      <SCInputMask
        name=''
        mask='99/99/9999'
        maxLength={2}
        value={props.rowData[props.field]}
        onBlur={handleBlur}
        onChange={handleControl}
        style={{ maxWidth: '60%' }}
      />
    );
  };

  const inputTextEditor = (props: any) => {
    const field = props.field;
    const rowIndex = props.rowIndex;

    const handleBlur = (e: any) => {
      const value = e.target.value;
      onEditorValueChange({ field, rowIndex }, value);
      const id = props.rowData.Matricula;

      if (id && !arrayIds.includes(id)) {
        setArrayIds(prevArrayIds => [...prevArrayIds, id]);
      }
    };

    const handleControl = (e: any) => {
    };

    return (
      <InputText
        type="text"
        defaultValue={props.rowData[props.field]}
        onBlur={handleBlur}
        onKeyPress={handleControl}
        style={{ maxWidth: '100%' }}
      />
    );
  };

  useEffect(() => {
    load();
    loadTurmas();
    comboParcelas();
  }, []);

  return (
    <div className="grid crud-demo">
      <div className="col-12">
        <div className="card">
          <div className='flex justify-content-center align-items-center p-2 border-round-top-md text-white' style={{ backgroundColor: '#0772B3' }}>
            <h5 className="m-0 flex flex-1 align-items-center justify-content-center">Inadimplentes x Observação</h5>
            <AjudaFormTela tarefa={tarefa} campo='' />
          </div>

          <SCFieldset legend='Filtros' className='col-12 mt-2 pt-0'>
            <div className='grid'>
              <div className="col-12 md:col-3">
                <SCDropdown
                  name="Situacao"
                  label='Situação'
                  options={SITUACAO_ALUNO}
                  optionLabel='descricao'
                  optionValue='value'
                  value={watchSituacao}
                  onChange={(e) => setValue('Situacao', e.target.value)}
                  style={{ width: '100%' }}
                />
              </div>
            </div>

            <div className='grid'>
              <div className="col-12 md:col-5">
                <SCDropdown
                  name="Turmas"
                  label='Turma'
                  options={turmas}
                  optionLabel='TurmaDescricao'
                  optionValue='Codigo'
                  value={watchTurmas}
                  onChange={(e) => setValue('Turmas', e.target.value)}
                  style={{ width: '100%' }}
                />
              </div>
            </div>

            <div className='grid'>
              <div className="col-12 md:col-2">
                <SCCalendar
                  control={control}
                  label='Data de Retorno Inicial'
                  name='DataRetornoInicial'
                  dateFormat='dd/mm/yy'
                  mask='99/99/9999'
                  placeholder='Data Inicial'
                />
              </div>

              <div className="col-12 md:col-2">
                <SCCalendar
                  control={control}
                  label='Data de Retorno Final'
                  name='DataRetornoFinal'
                  dateFormat='dd/mm/yy'
                  mask='99/99/9999'
                  placeholder='Data Final'
                />
              </div>
            </div>

            <div className='grid align-items-center'>
              <div className="col-12 md:col-2">
                <SCDropdown
                  name="ParcelaInicial"
                  label='Parcela Inicial'
                  options={parcelas}
                  optionLabel='value'
                  optionValue='value'
                  value={watchParcelaInicial}
                  onChange={(e) => setValue('ParcelaInicial', e.target.value)}
                  style={{ width: '100%' }}
                />
              </div>

              <div className="col-12 md:col-2">
                <SCDropdown
                  name="ParcelaFinal"
                  label='Parcela Final'
                  options={parcelas}
                  optionLabel='value'
                  optionValue='value'
                  value={watchParcelaFinal}
                  onChange={(e) => setValue('ParcelaFinal', e.target.value)}
                  style={{ width: '100%' }}
                />
              </div>

              <div className="col-3">
                <SCCheckbox
                  control={control}
                  name="ObsRegistradas"
                  label='Exibir somente os alunos com observações registradas'
                />
              </div>

              <div className="col-3">
                <SCCheckbox
                  control={control}
                  name="DebAcrescimo"
                  label='Não considerar débitos referente ao acréscimo'
                />
              </div>

              <div className='col-12 md:col-2 flex align-items-end'>
                <Button label='Pesquisar' icon="pi pi-search" className="p-button-info" type='button' onClick={pesquisa} />
              </div>
            </div>

          </SCFieldset>

          {loading ? (
            <Loading />
          ) : (
            <DataTable
              size='small'
              stripedRows
              value={listaInadimplentes}
              dataKey="MensalidadeId"
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="{first} a {last} de {totalRecords}"
              globalFilter={globalFilter}
              emptyMessage="Nenhum registro encontrado."
              header={null}
              scrollable
              scrollHeight="800px"
              responsiveLayout="scroll">
              <Column field="Turma" header="Turma" sortable  ></Column>
              <Column field="Matricula" header="Matrícula" headerStyle={{ width: '100px' }} sortable />
              <Column field="NomeAluno" header="Nome" headerStyle={{ width: 500 }} sortable  ></Column>
              <Column field="DescricaoSituacao" header="Sit" headerStyle={{ width: '50px' }} sortable ></Column>
              <Column field="DiaPadraoVencimento" header="Dia" headerStyle={{ width: '50px' }} sortable></Column>
              <Column field="ParcelasEmAberto" header="Parcelas Débito" headerStyle={{ width: 30 }} align='center' sortable></Column>
              <Column field="TotalEmAberto" header="Débito Nor." headerStyle={{ width: '150px' }} sortable></Column>
              <Column field="InadimplenteObs" header="Observação" headerStyle={{ width: '450px', background: '#19bfaf' }} sortable editor={inputTextEditor} body={(rowData) => rowData.InadimplenteObs} ></Column>
              <Column field="InadimplenteDataRetorno" header="Data Retorno" headerStyle={{ width: '100px', background: '#19bfaf' }} sortable editor={inputDateEditor} ></Column>
            </DataTable>
          )}

          <div className='grid flex justify-content-center'>
            <div className='col-12 md:col-10 pt-4 flex justify-content-center align-items-center'></div>
            <div className='col-12 md:col-2 flex justify-content-end mt-2 '>
              <Button label='Executar' icon="pi pi-plus-o" className="p-button-success" type='button' style={{ width: '100%' }} onClick={onSubmit} />
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default InadimplentesObservacao;